import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModuleListItem, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import useTeamMember from '@hooks/useTeamMember'

import { AgentsAndMembers } from '@functions/campaign'
import { AgentModel } from '@models/types'

interface AgentListItemProps {
  agent: AgentModel,
  member: AgentsAndMembers,
}

const AgentListItem = (props: AgentListItemProps) => {
  const { agent, member } = props

  const { member_role } = member || {}

  const { image, user } = useTeamMember(member)

  return (
    <ListItem boxProps={{ alignItems: 'center', borderBottom: '1px dashed' }} disableHover>
      {/*
       // @ts-expect-error TS2339 */}
      <UserProfileImage height={42} imageUrl={image?.thumb_url} width={42}>
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>

      <DashboardModuleListItem
        secondaryText={(
          <Box flexDirection="column">
            <Text fontSize="xsmall" color="bodyFontLightColor">{snakeToTitleCase(member_role)}</Text>
            <Text fontSize="xsmall" color="bodyFontLightColor">{agent.mobile}</Text>
            <Text fontSize="xsmall" color="bodyFontLightColor">{agent.email}</Text>
          </Box>
      )}
        // @ts-expect-error TS2339
        title={user.full_name}
      />
    </ListItem>
  )
}

export default AgentListItem
